import React from "react";
import { Ticket } from "../../../../../models/Ticket";
import { getPassTypeLabel } from "../../../../../utils/TicketPassHelper";

interface IProps {
  pass: Ticket;
}

const DetailsHeader: React.FC<IProps> = ({ pass }) => {
  return (
    <div className="ticket-details__header">
      <div className="ticket-details__name-section">
        {/* Pasek tytułowy modala i tak mówi "Szczegóły biletu/karnetu" — tu pokazujemy
            konkretny typ zamiast powtarzać ten sam napis. */}
        <span className="body-text-small text-color-light-gray">{getPassTypeLabel(pass)}</span>
        <h5>{pass.name}</h5>
      </div>
    </div>
  );
};

export default DetailsHeader;
